/* eslint-disable react/display-name */
import * as React from 'react';

const Youtube = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path d="M30 6C16.7 6 6 16.7 6 30s10.7 24 24 24 24-10.7 24-24S43.3 6 30 6zm-4.5 30.7V23.2l13 6.8-13 6.7z" />
  </svg>
);

export default Youtube;
